import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToUpperCase from 'utils/converters/any/fromAnyToUpperCase.util';

const fromAnyToSearchableName = (any) =>
  fromAnyToUpperCase(
    fromAnyToTrimmed(any)
      .normalize('NFD') // decompose combined graphemes
      .replace(/[\u0300-\u036f]/g, '') // gets rid of diacritics
      .replace(/^0+/, ''),
  );

export default fromAnyToSearchableName;
